import { cv } from "./cv";
import { hr } from "./hr";
import { chefs } from "./chefs";
import { doctor } from "./doctor";


export const primengThemes = {
  'hr': hr,
  'cv': cv,
  'chefs': chefs,
  'doctor': doctor
}